
// @mui material components
import Card from "@mui/material/Card";
import Grid from "@mui/material/Grid";
import Icon from "@mui/material/Icon";
import Tooltip from "@mui/material/Tooltip";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDButton from "components/MDButton";

// Images
import masterCardLogo from "assets/images/logos/mastercard.png";
import visaLogo from "assets/images/logos/visa.png";

import {useDispatch, useSelector} from "react-redux";
import MasterCard from "../../../examples/Cards/MasterCard";
import LocalStorage from "../../../utils/LocalStorage";
import React, {useEffect, useState} from "react";
import {downloadKitTemplate, getAllWarehouseList} from "../../../actions/inventory/inventoryAction";
import {noop} from "lodash";
import {check_default_card, default_card_client_secret, Logout, onErrorAlert} from "../../../actions";
import {useNavigate} from "react-router-dom";
import {Elements} from '@stripe/react-stripe-js';
import {loadStripe} from '@stripe/stripe-js';
import CheckoutForm from "./CheckoutForm";
import Fade from "@mui/material/Fade";
import Button from "@mui/material/Button";
import {Alert} from "@mui/material";
import {AlertTitle} from "@mui/lab";
import {pk} from "../../../config";
import {checkPermission, PERMISSION_DICT} from "../../../utils/Users_Roles_Permission";
import {useTranslation} from "react-i18next";

const stripePromise = loadStripe(process.env.REACT_APP_PK);
//const stripePromise = loadStripe(pk);
function PaymentLinkStripe() {

    const darkMode = useSelector(state => state?.common?.darkMode,(prev, next) => prev === next)
    const dispatch = useDispatch()
    const [loading,setLoading] = useState(false)
    const nav = useNavigate()
    const [defaultBtnAdded,setDefaultBtnAdded] = useState(false)
    const [clientSecret, setClientSecret] = useState(null)
    const [customerId, setCustomerId] = useState('');
    const defaultCard = useSelector(state => state?.system?.defaultCard,(prev, next) => prev === next)
    const haveCard = useSelector(state => state?.system?.haveCard,(prev, next) => prev === next)
    const [brandLogo,setBrandLogo] = useState(null)
    const {t,i18n} = useTranslation();
    const onError = (msg, code) => {
        dispatch(onErrorAlert(msg))
        if (code === 401) {
            dispatch(Logout(noop))
            nav('/')
        }
    }

    const saveFormData = () => {
        let formData = {}
        formData.ownerId = LocalStorage.getItem('ownerId')
        formData.username = LocalStorage.getItem('username')

        return formData
    }

    const onCheckSuccess = (status) => {
        setDefaultBtnAdded(status)
    }




    useEffect(()=>{

        let formData = {}
        if (saveFormData()) {
            formData = saveFormData()
        } else {
            return nav('/')
        }
        const axiosGet = async () => {
            await dispatch(check_default_card(formData,onCheckSuccess,onError))
        }

        axiosGet().then()

    },[])

    const options = {
        // passing the client secret obtained from the server
        clientSecret: clientSecret,
        locale: i18n.language
    };

    useEffect(() => {
        if(defaultCard){
            setBrandLogo(defaultCard?.brand)
        }
    }, [defaultCard]);

    const onClientSecretSuccess = (data) => {
        setClientSecret(
            data?.clientSecret)
        setCustomerId(data?.customerId);
    }

    const handleAddDefaultCard = async () => {
        let formData = {}
        if (saveFormData()) {
            formData = saveFormData()
        } else {
            return nav('/')
        }
        await dispatch(default_card_client_secret(formData, onClientSecretSuccess, onError))
    }

    return (
        <React.Fragment >

            <MDBox pt={2} px={2} display="flex" justifyContent="space-between" alignItems="center">
                <MDTypography variant="h6" fontWeight="medium">
                    {t("AccountPage.Payment Methods")}
                </MDTypography>
                {
                    !defaultBtnAdded &&
                    <MDButton
                        variant={'gradient'}
                        color={'dark'}
                        disabled = {defaultBtnAdded || !checkPermission(PERMISSION_DICT.AccountCustomerInfo) }
                        onClick={handleAddDefaultCard}
                    >
                        <Icon sx={{ fontWeight: "bold" }}>add</Icon>
                        &nbsp;{t('AccountPage.add Default card')}
                    </MDButton>
                }
            </MDBox>
            {defaultBtnAdded && <MDBox mt={2} sx={{display:'flex',justifyContent:'center'}}>
                {darkMode?<Alert variant={'filled'} severity="success" color={'info'}>
                    {t("AccountPage.You have added the default credit card. Please look forward to more features coming soon!")}
                </Alert>:<Alert severity="success" color={'info'}>
                    {t("AccountPage.You have added the default credit card. Please look forward to more features coming soon!")}
                </Alert>}
            </MDBox>}
            <MDBox p={2}>
                <Grid container alignItems={'flex-start'} >

                    <Grid sx={{display:'flex',justifyContent:'center',flexDirection:'column', alignItems:'center',marginTop:5}} item xs={12} md={6} xl={clientSecret?4:12}>
                        { <MasterCard number={1000000000000000}
                                      last4={defaultCard?.last4}
                                      holder={LocalStorage.getItem('username')}
                                      expires={defaultCard?`${defaultCard?.expMonth?.toString()?.padStart(2, '0')}/${defaultCard?.expYear}`:'XX/XX'}
                                      brandLogo={brandLogo}

                        />

                        }
                    </Grid>

                    <Fade timeout={200} in={true} mountOnEnter unmountOnExit >
                    <Grid item xs={12} md={6} xl={8} p={3}>

                            {clientSecret &&
                                <Elements stripe={stripePromise} options={options}>
                                    <CheckoutForm customerId={customerId} defaultBtnAdded={defaultBtnAdded} setDefaultBtnAdded={setDefaultBtnAdded}/>
                                </Elements>
                            }

                    </Grid>
                    </Fade>
                </Grid>
                {/*<Grid container spacing={3}>*/}
                {/*    <Grid item xs={12} md={6}>*/}
                {/*        <MDBox*/}
                {/*            borderRadius="lg"*/}
                {/*            display="flex"*/}
                {/*            justifyContent="space-between"*/}
                {/*            alignItems="center"*/}
                {/*            p={3}*/}
                {/*            sx={{*/}
                {/*                border: ({ borders: { borderWidth, borderColor } }) =>*/}
                {/*                    `${borderWidth[1]} solid ${borderColor}`,*/}
                {/*            }}*/}
                {/*        >*/}
                {/*            <MDBox component="img" src={masterCardLogo} alt="master card" width="10%" mr={2} />*/}
                {/*            <MDTypography variant="h6" fontWeight="medium">*/}
                {/*                ****&nbsp;&nbsp;****&nbsp;&nbsp;****&nbsp;&nbsp;*****/}
                {/*            </MDTypography>*/}
                {/*            <MDBox ml="auto" lineHeight={0} color={darkMode ? "white" : "dark"}>*/}
                {/*                <Tooltip title="Edit Card" placement="top">*/}
                {/*                    <Icon sx={{ cursor: "pointer" }} fontSize="small">*/}
                {/*                        edit*/}
                {/*                    </Icon>*/}
                {/*                </Tooltip>*/}
                {/*            </MDBox>*/}
                {/*        </MDBox>*/}
                {/*    </Grid>*/}
                {/*    <Grid item xs={12} md={6}>*/}
                {/*        <MDBox*/}
                {/*            borderRadius="lg"*/}
                {/*            display="flex"*/}
                {/*            justifyContent="space-between"*/}
                {/*            alignItems="center"*/}
                {/*            p={3}*/}
                {/*            sx={{*/}
                {/*                border: ({ borders: { borderWidth, borderColor } }) =>*/}
                {/*                    `${borderWidth[1]} solid ${borderColor}`,*/}
                {/*            }}*/}
                {/*        >*/}
                {/*            <MDBox component="img" src={visaLogo} alt="master card" width="10%" mr={2} />*/}
                {/*            <MDTypography variant="h6" fontWeight="medium">*/}
                {/*                ****&nbsp;&nbsp;****&nbsp;&nbsp;****&nbsp;&nbsp;*****/}
                {/*            </MDTypography>*/}
                {/*            <MDBox ml="auto" lineHeight={0} color={darkMode ? "white" : "dark"}>*/}
                {/*                <Tooltip title="Edit Card" placement="top">*/}
                {/*                    <Icon sx={{ cursor: "pointer" }} fontSize="small">*/}
                {/*                        edit*/}
                {/*                    </Icon>*/}
                {/*                </Tooltip>*/}
                {/*            </MDBox>*/}
                {/*        </MDBox>*/}
                {/*    </Grid>*/}
                {/*</Grid>*/}
            </MDBox>
        </React.Fragment>
    );
}

export default PaymentLinkStripe;
